import React, { useState, useEffect, useRef, FC } from 'react'
import { styled, Typography, TypographyProps } from '@mui/material'

interface IProps {
  maxHeight: number
}

const TextOverflowDetector: FC<React.PropsWithChildren<IProps>> = (props) => {
  const contentRef = useRef<HTMLDivElement>(null)
  const [isOverflowing, setIsOverflowing] = useState(false)
  const [scrollHeight, setScrollHeight] = useState(0)

  useEffect(() => {
    const checkOverflow = () => {
      if (contentRef.current) {
        setIsOverflowing(contentRef.current.scrollHeight > props.maxHeight)
        setScrollHeight(contentRef.current.scrollHeight)
      }
    }
    checkOverflow()
    window.addEventListener('resize', checkOverflow)
    return () => window.removeEventListener('resize', checkOverflow)
  }, [props])

  return (
    <>
      <span
        ref={contentRef}
        style={{
          display: 'block',
          maxHeight: isOverflowing ? '4.5em' : scrollHeight,
          overflow: 'hidden',
          position: 'relative',
          transition: 'max-height 0.3s ease'
        }}
      >
        {props.children}
      </span>
      <TextAction onClick={() => setIsOverflowing(!isOverflowing)}>{isOverflowing ? '...more' : 'Show less'}</TextAction>
    </>
  )
}

export default TextOverflowDetector

const TextAction = styled((p: TypographyProps) => <Typography variant='body2' {...p} />)({
  fontWeight: 700,
  cursor: 'pointer',
  transition: 'linear 0.3s',
  '&:hover': {
    color: '#0073e6'
  }
})
